export interface IMicrositeRecipientPendApproval {
    micrositeRecipientId: number,
    recipientFirstName: string,
    recipientLastName: string,
    centerId: number
}